import React, {useMemo, useRef, useState} from 'react';
import PendCellRenderer from "../../../components/cell-renderer/pend-cell-renderer";
import Card from "../../../components/card";
import {AgGridReact} from "ag-grid-react";
import {LocalizationAgGrid} from "../../../utils/localization-ag-grid";
import moment from "moment";
import TruncateCellRenderer from "../../../components/cell-renderer/truncate-cell-renderer";

const OrdersTable = ({orders}) => {
    const [columnDefs] = useState([
        { field: "id", headerName: "ID", width: 70 },
        { field: "date_initial", headerName: "Abertura", valueFormatter: ({value}) => moment(value).format("DD/MM/YYYY HH:mm"), flex: 1, minWidth: 200 },
        { field: "date_final", headerName: "Encerramento", valueFormatter: ({value}) => moment(value).format("DD/MM/YYYY HH:mm"), flex: 1, minWidth: 200 },
        { field: "", headerName: "Pendências", sortable: false, cellRenderer: PendCellRenderer, width: 180 },
        { field: "pend_multiway_desc", headerName: "Multiway", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 200 },
        { field: "pend_client_desc", headerName: "Clientes", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 200 },
        { field: "pend_terceiros_desc", headerName: "Terceiros", cellRenderer: TruncateCellRenderer, flex: 1, minWidth: 200 },
    ]);

    const gridRef = useRef();

    const defaultColDef = useMemo(() => ({resizable: false}), []);

    return (
        <Card title="Orderns de serviço" wrapperClass="mt-5">
            <div className={"ag-theme-quartz grid"}>
                <AgGridReact
                    ref={gridRef}
                    rowHeight={32}
                    rowData={orders}
                    columnDefs={columnDefs}
                    defaultColDef={defaultColDef}
                    animateRows={false}
                    suppressRowClickSelection={true}
                    suppressCellFocus={true}
                    gridOptions={{localeText: LocalizationAgGrid}}
                    domLayout='autoHeight'
                />
            </div>
        </Card>
    );
};

export default OrdersTable;